module.exports = __webpack_public_path__ + "static/media/8OLA15.975b0ccb.jpg";